<template>
  <b-card>
    <FormBuilder
      label="Sale"
      create
      :fields="fields"
      :loading-submit="$store.state.sale.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/sale'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('sale/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
